import React, { Component } from "react";
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";
import { config } from "../shared/config";
import * as util from '../shared/commons';
export default class PaymentWayCombo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            loading: true
        }
    }
    componentDidMount = () => {
        this.reloadItems();
    }
    reloadItems = () => {
        var items = [
            { "id": 1, "OptionTitle": "واریز به حساب", "OptionValue": 1, itemValue: { id: 1, title: "واریز به حساب" } },
            { "id": 2, "OptionTitle": "نقدواریز به حساب", "OptionValue": 2, itemValue: { id: 2, title: "نقد" } },
            { "id": 3, "OptionTitle": "کارتخوان", "OptionValue": 3, itemValue: { id: 3, title: "کارتخوان" } },
        ];
        if (this.props.addCheque) {
            if (this.props.addCheque === true) {
                items.push({ "id": 3, "OptionTitle": "چک", "OptionValue": 4, itemValue: { id: 4, title: "چک" } });
            }
        }
        var newState = { ...this.state };

        newState["loading"] = false;

        newState["items"] = items;

        this.setState(newState);
    }
    onInputChange = (e) => {
        var val = e;
        if (val) {
            if (this.props.returnFullItem === true) {
                this.props.onChange(val);
            }
            else {
                this.props.onChange(val.OptionValue);
            }
        }
        else {
            if (this.props.returnFullItem === true) {
                this.props.onChange({});
            }
            else {
                this.props.onChange("");
            }
        }
    }
    getItemIndex = (items, value) => {
        if (items === null) return -1;
        if (items.length === 0) return -1;
        for (var i = 0; i < items.length; i++) {
            if (this.props.returnFullItem === true) {
                if (items[i].id === value.id) return i;
            }
            else {
                if (items[i].OptionValue === value) return i;
            }
        }
        return -1;
    }

    render() {
        var ind = this.getItemIndex(this.state.items, this.props.value);
        var ci = null;
        if (ind >= 0) ci = this.state.items[ind];
        var visible = true;
        if (this.props.visible === false)
            visible = false;
        var display = "block";
        if (!visible) display = "none";

        return (
            <>
                <div className="field" style={{ display: display }}>
                    <label className="font-bold" style={{ width: "100%" }}>
                        روش پرداخت
                    </label>
                    <Dropdown disabled={this.props.disabled} value={ci} onChange={(e) => this.onInputChange(e.value)} options={this.state.items} optionLabel="OptionTitle"
                        placeholder={"روش پرداخت را انتخاب کنید"} className="w-full" checkmark={true} highlightOnSelect={true} filter showClear style={{ width: "100%" }} loading={this.state.loading} />
                </div>
            </>
        );
    }
}

